import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
	const [qrCode, setQrCode] = useState("");

	useEffect(() => {
		if (!open || !whatsAppId) return undefined;

		const fetchSession = async (silent = false) => {
			try {
				const { data } = await api.get(`/whatsapp/${whatsAppId}`);
				setQrCode(data.qrcode || "");
				if (data.qrcode === "") {
					onClose();
				}
			} catch (err) {
				if (!silent) {
					toastError(err);
				}
			}
		};

		fetchSession();
		const interval = setInterval(() => fetchSession(true), 8000);

		return () => clearInterval(interval);
	}, [open, whatsAppId, onClose]);

	useEffect(() => {
		if (!whatsAppId) return;
		const socket = openSocket();

		const handleSessionUpdate = data => {
			if (data.action !== "update" || data.session.id !== whatsAppId) {
				return;
			}

			setQrCode(data.session.qrcode);

			if (data.session.qrcode === "") {
				onClose();
			}
		};

		socket.on("whatsappSession", handleSessionUpdate);

		return () => {
			socket.off("whatsappSession", handleSessionUpdate);
			socket.disconnect();
		};
	}, [whatsAppId, onClose]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
			<DialogContent>
				<Paper elevation={0}>
					<Typography color="primary" gutterBottom>
						{i18n.t("qrCode.message")}
					</Typography>
					{qrCode ? (
						<QRCode value={qrCode} size={256} />
					) : (
						<span>Waiting for QR Code</span>
					)}
				</Paper>
			</DialogContent>
		</Dialog>
	);
};

export default React.memo(QrcodeModal);
